import { useState } from "react";
import { Copy, Check } from "lucide-react";
import { toast } from "sonner";
import { copyText } from "@/lib/clipboard";

// Stat card whose value can be copied to the clipboard (MLS numbers, VINs, etc.).
export default function CopyStat({ label, value, testId }) {
  const [copied, setCopied] = useState(false);
  const canCopy = value != null && value !== "" && value !== "—";

  const doCopy = async () => {
    if (!canCopy) return;
    const ok = await copyText(value);
    if (ok) {
      setCopied(true);
      toast.success(`${label} copied`);
      setTimeout(() => setCopied(false), 1500);
    } else {
      toast.error("Could not copy");
    }
  };

  return (
    <div className="metric-empty p-4" data-testid={testId}>
      <div className="font-mono-data text-[10px] uppercase tracking-wider text-muted-foreground">{label}</div>
      <div className="flex items-center justify-between gap-2 mt-1">
        <div className="font-mono-data text-lg truncate">{value ?? "—"}</div>
        {canCopy && (
          <button
            onClick={doCopy}
            data-testid={`${testId}-copy`}
            title={`Copy ${label}`}
            className="shrink-0 text-muted-foreground hover:text-accent transition-colors"
          >
            {copied ? <Check className="w-4 h-4 text-emerald-500" /> : <Copy className="w-4 h-4" />}
          </button>
        )}
      </div>
    </div>
  );
}
